import { DatepickerOverrides } from 'baseui/datepicker'
import { SelectOverrides } from 'baseui/select'
import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: $theme.sizing.scale700
}))

export const Title = styled('h1', ({ $theme }) => ({
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: '2.8rem',
    margin: 'auto'
}))

export const Subtitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    margin: 0,
    fontWeight: 700
}))

export const LotName = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    fontWeight: 700,
    color: '#B3BBC7'
}))

export const EditIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.primary,
    fontSize: '2.4rem',
    cursor: 'pointer'
}))

export const DropdownTitle = styled('span', ({ $theme }) => ({
    color: '#667085',
    fontSize: '1.2rem',
    lineHeight: '1.8rem',
    fontWeight: 300
}))

export const SpinnerContainer = styled('div', ({ $theme }) => ({
    padding: `0 ${$theme.sizing.scale700}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))

export const SelectOverride: SelectOverrides = {
    Root: {
        style: ({ $theme }) => ({
            width: '100%'
        })
    }
}

export const DatePickerOverrides: DatepickerOverrides = {
    Popover: {
        props: {
            overrides: {
                Body: {
                    style: {
                        maxWidth: '98vw',
                        overflow: 'hidden'
                    }
                }
            }
        }
    },
    Root: {
        style: {
            backgroundColor: '#fff'
        }
    },
    Day: {
        style: ({ $theme, $selected, $isHighlighted, $disabled, $outsideMonth }) => ({
            ':after': {
                backgroundColor: '#fff'
            },

            ...(($isHighlighted || $selected) && {
                ':after': {
                    backgroundColor: $theme.colors.primary,
                    color: '#fff',
                    // mobile only
                    [$theme.mediaQuery.small]: {
                        left: '2px !important'
                    }
                }
            }),
            ...($disabled && {
                color: '#adadad'
            }),
            ':before': {
                backgroundColor: '#fff',
                ...(!$outsideMonth && {
                    backgroundColor: '#EFF3FE !important'
                })
            }
        })
    },
    MonthYearSelectIconContainer: {
        style: {
            display: 'none'
        }
    },
    MonthYearSelectButton: {
        style: {
            padding: '4px'
        }
    },
    CalendarHeader: {
        style: {
            width: '100%'
        }
    },
    TimeSelect: {
        props: {
            'data-testid': 'time-select'
        }
    },
    TimeSelectFormControl: {
        props: {
            'data-testid': 'time-picker-dropdown',
            overrides: {
                Label: {
                    style: {
                        display: 'none'
                    }
                }
            }
        }
    }
}

export const BaseButtonOverrides = {
    BaseButton: {
        style: {
            width: '100%'
        }
    }
}
